import { animate, state, style, transition, trigger } from '@angular/animations';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { ShebaGtmClickDirective, ShebaGtmEventDirective } from 'app/core/services/google-tag-manager/gtm.directive';
import { ShebaButtonComponent } from 'app/shared/components/button/button.component';
import { LanguageService } from 'app/shared/services/language.service';
import { ArrowDownIcon } from '../../../../assets/icons/arrow-down/arrow-down';
import { SeoService } from 'app/core/services/seo.service';
import { LanguageBilingualPaths } from 'app/core/helpers/models/base-page.model';

@Component({
  selector: 'sheba-lang-select-dropdown',
  exportAs: 'langSelectDropdown',
  templateUrl: './sheba-lang-select-dropdown.component.html',
  standalone: true,
  styleUrl: './sheba-lang-select-dropdown.component.scss',
  animations: [
    trigger('openClose', [
      state(
        '*',
        style({
          opacity: 1,
          height: '*'
        })
      ),
      state(
        'void',
        style({
          opacity: 0.0,
          transform: 'translateY(-10%)'
        })
      ),
      transition('* => void', [animate('100ms')]),
      transition('void => *', [animate('150ms')])
    ])
  ],
  host: {
    class: 'contents'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    OverlayModule,
    A11yModule,
    NgClass,
    ArrowDownIcon,
    MatRippleModule,
    ShebaButtonComponent,
    ShebaGtmClickDirective,
    ShebaGtmEventDirective
  ]
})
export class ShebaLangSelectDropdownComponent {
  isOpen = signal(false);
  #seoService = inject(SeoService);
  blockScrollStrategy = inject(ScrollStrategyOptions).block();

  get bilingualPaths(): LanguageBilingualPaths | undefined {
    return this.#seoService.bilingualPaths;
  }

  get contentType(): string | undefined {
    return this.#seoService.contentType;
  }

  constructor(protected languageService: LanguageService) {
    effect(() => {
      if (this.isOpen()) {
        this.blockScrollStrategy.enable();
      } else {
        this.blockScrollStrategy.disable();
      }
    });
  }
}
